<template>
  <article
    v-if="src"
    data-qa="banner_item"
    class="banner-item rounded-20"
  >
    <v-img
      data-qa="banner_item_image"
      class="rounded-20"
      :src="src"
      :aspect-ratio="isMobile ? 350 / 240 : 1148 / 320"
      contain
    />
  </article>
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'

defineProps<{
  src?: string
}>()

const isMobile = useIsMobile()
</script>

<style scoped lang="scss">
.banner-item {
  width: 100%;
  background-color: var(--lpu-branding-color-background);
  overflow: hidden;
}
</style>
